const normalizeAddressName = (name: string): string => name.normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[đĐ]/g, 'd')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ');

/** Search visible address names; option values remain the original saved IDs. */
export const filterAddressOption = (input: string, option?: { label?: unknown; children?: unknown }): boolean => {
    const name = option?.label ?? option?.children;
    return typeof name === 'string' && normalizeAddressName(name).includes(normalizeAddressName(input));
};

export const addressSearchProps = { showSearch: true, filterOption: filterAddressOption };
